module.exports = __webpack_public_path__ + "static/media/PDF7.99e6f30e.pdf";